import { FormattedMessage } from "react-intl";

const UnlimitedEmailNotifications = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.unlimitedEmailNotifications.content.body"
                    defaultMessage="Customers, agents, and admins can receive unlimited email notifications about request activity."
                />
            </p>
        </div>
    );
};

export default UnlimitedEmailNotifications;
